const ITEMS = [
  "1 Day Theory",
  "2 Days Hands-On Practice",
  "CPD Accredited",
  "Visceral + Lymphatic Fusion",
  "Individual Therapist: £800",
  "Salon Team: £3,000",
  "London Studios",
];

export const Marquee = () => (
  <div data-testid="marquee-bar" className="border-y border-cream bg-sand py-4 overflow-hidden">
    <div className="flex w-max animate-marquee items-center gap-10 font-monolbl text-xs uppercase tracking-widest text-forest">
      {[0, 1].map((dup) => (
        <div key={dup} aria-hidden={dup === 1} className="flex items-center gap-10">
          {ITEMS.map((item) => (
            <span key={`${dup}-${item}`}>• {item}</span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
